import requestAction from '../../utils/requestAction'

export const fetchProductGroup = (productGroupId: string) =>
  requestAction('PRODUCTGROUP_DETAIL')(`productGroups/${productGroupId}`, 'GET')
